import React from 'react';
import { Document, Page, Text, View, Image } from '@react-pdf/renderer';
import { sharedStyles } from './SharedPDFStyles';

const LokalOrganizasyonReportPDF = ({ data, logos }) => {
  return (
    <Document>
      <Page size="A4" style={sharedStyles.page}>
        <View style={sharedStyles.header}>
          <View style={sharedStyles.businessInfo}>
            {logos.length > 0 && (
              <View style={sharedStyles.logoContainer}>
                {logos.slice(0, 3).map((logo, index) => (
                  <Image key={index} src={logo.data} style={sharedStyles.logo} />
                ))}
              </View>
            )}
            <Text style={sharedStyles.businessName}>{data.organizationName || 'Organization Name'}</Text>
            <Text style={sharedStyles.businessDetails}>Event: {data.eventName}</Text>
            <Text style={sharedStyles.businessDetails}>Location: {data.location}</Text>
          </View>
          <View style={sharedStyles.documentTitle}>
            <Text style={sharedStyles.title}>Event Budget Report</Text>
            <Text style={sharedStyles.documentInfo}>Date: {data.date}</Text>
            <Text style={sharedStyles.documentInfo}>Event Date: {data.eventDate}</Text>
          </View>
        </View>

        <View style={sharedStyles.section}>
          <Text style={sharedStyles.sectionTitle}>Event Budget</Text>
          <View style={sharedStyles.table}>
            <View style={sharedStyles.tableHeader}>
              <Text style={sharedStyles.tableCell}>Category</Text>
              <Text style={{ ...sharedStyles.tableCell, flex: 2 }}>Description</Text>
              <Text style={sharedStyles.tableCellRight}>Planned</Text>
              <Text style={sharedStyles.tableCellRight}>Actual</Text>
              <Text style={sharedStyles.tableCellRight}>Difference</Text>
            </View>
            {data.budget && data.budget.map((item, index) => (
              <View key={index} style={sharedStyles.tableRow}>
                <Text style={sharedStyles.tableCell}>{item.category}</Text>
                <Text style={{ ...sharedStyles.tableCell, flex: 2 }}>{item.description}</Text>
                <Text style={sharedStyles.tableCellRight}>${item.plannedAmount.toFixed(2)}</Text>
                <Text style={sharedStyles.tableCellRight}>${item.actualAmount.toFixed(2)}</Text>
                <Text style={sharedStyles.tableCellRight}>${item.difference.toFixed(2)}</Text>
              </View>
            ))}
          </View>
        </View>

        <View style={sharedStyles.summary}>
          <View style={sharedStyles.summaryBox}>
            <View style={sharedStyles.summaryRow}>
              <Text style={sharedStyles.summaryLabel}>Total Planned:</Text>
              <Text style={sharedStyles.summaryValue}>${data.totalPlanned?.toFixed(2) || '0.00'}</Text>
            </View>
            <View style={sharedStyles.summaryRow}>
              <Text style={sharedStyles.summaryLabel}>Total Actual:</Text>
              <Text style={sharedStyles.summaryValue}>${data.totalActual?.toFixed(2) || '0.00'}</Text>
            </View>
            <View style={sharedStyles.summaryTotal}>
              <Text style={sharedStyles.summaryTotalLabel}>Budget Difference:</Text>
              <Text style={sharedStyles.summaryTotalValue}>${data.totalDifference?.toFixed(2) || '0.00'}</Text>
            </View>
          </View>
        </View>

        {data.notes && (
          <View style={sharedStyles.notes}>
            <Text style={sharedStyles.notesTitle}>Event Summary:</Text>
            <Text style={sharedStyles.notesText}>{data.notes}</Text>
          </View>
        )}

        <View style={sharedStyles.footer}>
          <Text>© 2025 Software Development East Africa (SODEAF) — Innovating for a smarter Africa.</Text>
          <Text>Crafted by Eng. Mohamed Ibrahim Abdi (Moha-Qadar) | mohamedqadar280@gmail.com</Text>
        </View>
      </Page>
    </Document>
  );
};

export default LokalOrganizasyonReportPDF;
